import { IEntityMetricsResponse } from "api/entities/metrics";
import { IStyleableComponentProps } from "components/shared-ui/common/component-props";
import { DotIcon, DotIconColor } from "components/shared-ui/icons/dot-icon";
import React from "react";
import { Formatters } from "../../../../helper/formatters";
import styles from "./metrics-info.module.scss";
import clsx from "clsx";

const statusToColorMap = {
  "up": DotIconColor.Green,
  "down": DotIconColor.Red,
}

const statusToTooltipMap = {
  "up": "Up",
  "down": "Down",
}

export interface IsMetricsInfoProps extends IStyleableComponentProps {
  metrics: IEntityMetricsResponse;
  entityName: string;
}

export function MetricsInfo({ metrics, entityName, className }: IsMetricsInfoProps) {
  if (!metrics) {
      return <></>;
  }

  return (
      <section className={clsx(className, styles.root)}>
        <div className={styles.row}>

          <div>
            Status:
          </div>

          <DotIcon
           className={styles[`status-${className}`]}
           testId={`icon-status-${statusToTooltipMap[metrics.status]}}`}
           color={statusToColorMap[metrics.status]}
           tooltip={statusToTooltipMap[metrics.status]}
          />
        </div>

        <section className={styles.usage}>
          <div>Usage:</div>

          <div className={clsx(styles['row'], styles['subsection'])}>
              <div>{entityName} Size:</div>
              <div>{
                  metrics?.sizeBytes >= 0
                      ? Formatters.formatStorageSpace(metrics.sizeBytes)
                      : "N/A"
              }
              </div>
          </div>

          <div className={clsx(styles.row, styles.subsection)}>
              <div>Objects:</div>
              <div>{
                  metrics?.objectNumber >= 0
                      ? metrics.objectNumber
                      : "N/A"
              }
              </div>
          </div>
        </section>
      </section>
  );
}
